import React from 'react';
import {
  Grid,
  Avatar,
  ListItemText,
  withStyles,
  Icon,
  ListItemAvatar,
} from '@material-ui/core';
import { ButtonUI, ToggleUI } from '../../common';
import InfoItem from './InfoItem';
import { Config } from '../../../other';
import { useSelector } from 'react-redux';

const BillCardBody = ({
  show,
  bill,
  title,
  classes,
  component,
  iconAvatar,
  isSuscribed,
  isCardWithHeader,
  setOpenSetIdPayment,
}) => {
  const idCountry = useSelector((state) => state.tienda.Country_idCountry);

  if (Object.entries(bill).length > 0) {
    const validationTree = {
      ARG: {
        // Country
        1: {
          // pagado
          true: true, // suscripto
          false: true, // no suscripto
        },
        0: {
          // no pagado
          true: false, // suscripto
          false: true, // no suscripto
        },
      },
      COL: {
        // Country
        1: {
          // pagado
          true: false, // suscripto
          false: false, // no suscripto
        },
        0: {
          // no pagado
          true: false, // suscripto
          false: true, // no suscripto
        },
      },
    };

    const buttonShow =
      bill &&
      Object.keys(bill).length > 0 &&
      validationTree[idCountry][bill.paga][isSuscribed];

    return (
      <Grid
        container
        alignItems="center"
        component={isCardWithHeader ? 'div' : component}
        className={classes.card_body_container}
      >
        <ListItemAvatar>
          <Avatar
            classes={{
              root: classes.card_avatar,
            }}
          >
            <Icon classes={{ root: classes.avatar_icon }}>{iconAvatar}</Icon>
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={title}
          classes={{ root: classes.list_text }}
          secondary={
            <InfoItem
              bill={bill}
              show={show}
              setOpenSetIdPayment={setOpenSetIdPayment}
            />
          }
        />
        <ToggleUI show={buttonShow}>
          <Grid className={classes.button_wrapper} item xs={12} md={12} lg={3}>
            <ButtonUI
              type="link"
              fullWidth={true}
              disabled={Boolean(bill.paga && !bill.facturada)}
              open_new_tab={Boolean(bill.paga)}
              external_link={Boolean(bill.paga)}
              label={bill.paga ? 'Ver' : 'Pagar'}
              link={
                bill.paga
                  ? bill.pdf ||
                    `${Config.BACKEND_ENDPOINT}/tienda/comprobante/${bill.id}`
                  : '/plan/metodo-pago'
              }
            />
          </Grid>
        </ToggleUI>
      </Grid>
    );
  }

  return <></>;
};

const styles = (theme) => ({
  card_body_container: {
    marginTop: '12px',
  },
  card_avatar: {
    width: '50px',
    height: '50px',
    background: '#53B755',
  },
  avatar_icon: {
    fontSize: '28px',
  },
  button_wrapper: {
    marginTop: '24px',
    [theme.breakpoints.up('lg')]: {
      marginTop: '0',
    },
  },
  list_text: {
    paddingRight: '0',
  },
});

export default withStyles(styles)(BillCardBody);
